Controller.$inject = [];

function Controller() {

}

export function HuiPageStickyPanel() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui hui-page-title hui-page-sticky-panel" ng-transclude></div>`;
        }
    };
}